import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';

import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import FormatHelpers from '../../../helpers/format';
import Permissions from '../../../app/services/permissions';
import UserConfirmationModal from '../../../components/pages/userConfirmationModal';
import { getDepositsERPOptionsList } from '../../../app/store/actions/deposits';
import {
  generateStockMirror,
} from '../../../app/store/actions/stocks';
import Select from '../../../components/form/select';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';

class AllStockBalance extends React.Component {
  constructor(props) {
    super(props);

    this.page = 0;
    this.pageSize = 10;
    this.sorted = [];
    this.filtered = [];

    this.defaultSorted = [{
      id: 'productCode',
      desc: false,
    }, {
      id: 'branchCode',
      desc: false,
    }];

    this.state = {
      pages: 0,
      totalDataLength: 0,
      showModalUserConfirmation: false,
      showModalSelectDeposit: false,
      listDeposit: [],
      deposit: '',
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE277' /* Descrição */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 350,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2090' /* Fabricante */),
        accessor: 'manufacturer',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE695' /* Código Complementar */),
        accessor: 'complementCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE696' /* Informação Complementar */),
        accessor: 'complementInfo',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE530' /* Disponível */),
        accessor: 'balance',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
        filterable: false,
      }, {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 110,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
        filterable: false,
      }, {
        Header: I18n.t('BEE482' /* Alocada */),
        accessor: 'allocated',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
        filterable: false,
      },
    ];
  }

  handleStockMirror = async () => {
    this.setState({ showModalUserConfirmation: true });
  };

  userConfirmation = async (confirm) => {
    if (confirm) {
      const listDeposit = await this.props.getDepositsERPOptionsList();
      this.setState({
        listDeposit,
      });
    }
    this.setState({ showModalUserConfirmation: false, showModalSelectDeposit: confirm });
  };

  confirmStockMirror = async () => {
    const { deposit } = this.state;

    if (!deposit) {
      addNotification(
        'danger',
        I18n.t('BEE4198' /* Espelhar Estoque */),
        I18n.t('BEE3642' /* Nenhum depósito selecionado */),
        'top-right',
      );
    } else {
      try {
        await this.props.generateStockMirror(this.props.mainBranch, deposit.value);

        addNotification(
          'success',
          I18n.t('BEE4198' /* Espelhar Estoque */),
          I18n.t('BEE4201' /* Espelho do estoque enviado com sucesso! */),
          'top-right',
        );

        this.setState({ showModalSelectDeposit: false });
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;

        if (error && error.message) {
          const messageError = (error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;

          addNotification('danger', I18n.t('BEE4198' /* Espelhar Estoque */), messageError, 'top-right');
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4198' /* Espelhar Estoque */),
            I18n.t('BEE1960' /* Erro ao gravar os dados */),
            'top-right',
          );
        }
      }
    }
  };

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  selectedLine = async (selectedProduct) => {
    this.props.getProductsStockBalance(selectedProduct.productCode, selectedProduct.branchCode);
    this.setState({ selectedProductId: selectedProduct.id });
  };

  getAllStockBalances = async () => {
    const data = await this.props.getAllStockBalances({
      page: this.page,
      pageSize: this.pageSize,
      filtered: this.filtered,
      sorted: this.sorted,
    });
    this.setState({ pages: data.pages, totalDataLength: data.totalDataLength });
  };

  render() {
    const { allStockBalancesList = [] } = this.props;
    const {
      pages,
      selectedProductId,
      totalDataLength,
      showModalUserConfirmation,
      showModalSelectDeposit,
      listDeposit = [],
      deposit,
    } = this.state;

    return (
      <div>
        <Table
          downloadCSV
          headerTitle={I18n.t('BEE1761' /* Saldo do Estoque - Detalhes */)}
          wikiHelp={ROUTES.DETAILED_STOCK_BALANCE_HELP}
          panelHeaderProps={{
            onClickReload: this.getAllStockBalances,
            children: I18n.t('BEE27' /* Produtos */).toUpperCase(),
          }}
          filterable
          data={allStockBalancesList}
          totalDataLength={totalDataLength}
          columns={this.tableColumns}
          expander
          defaultSorted={this.defaultSorted}
          defaultPageSize={this.pageSize}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          refActionButtons={() => (
            <div className="ml-auto">
              {this.props.enableStockMirror && !Permissions.checkPermission(ROUTES.P_CONSULT_ACCESS_STOCK_MIRROR) && (
                <button
                  type="button"
                  className="btn btn-success btn-sm btn-rounded pl-2 pr-3"
                  onClick={this.handleStockMirror}
                >
                  <i className="ion ion-md-refresh fa-2x fa-fw pull-left m-r-2" style={{ fontSize: '1rem' }} />
                  {I18n.t('BEE4198' /* Espelhar Estoque */)}
                </button>
              )}
            </div>
          )}
          manual
          pages={pages}
          onFetchData={(state) => {
            this.page = state.page;
            this.pageSize = state.pageSize;
            this.filtered = state.filtered;
            this.sorted = state.sorted;
            this.getAllStockBalances();
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.original) {
              const dateForCalculation = (rowInfo.original.outboundPreExpiration)
                ? moment(rowInfo.original.expirationDate)
                  .subtract(parseInt(rowInfo.original.outboundPreExpiration, 10), 'days')
                : rowInfo.original.expirationDate;

              const color = ((rowInfo.original.controlExpirationDate && rowInfo.original.expirationDate)
                && (moment().isSameOrAfter(dateForCalculation, 'day')
                  ? '#bf4441'
                  : 'black')) || 'black';

              return {
                onClick: () => {
                  this.selectedLine(rowInfo.original);
                },
                style: {
                  color,
                  background: selectedProductId && rowInfo.original.id === selectedProductId ? 'silver' : 'white',
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
        />

        <UserConfirmationModal
          openModal={showModalUserConfirmation}
          confirm={(confirm) => this.userConfirmation(confirm)}
        />

        <Modal isOpen={showModalSelectDeposit}>
          <ModalHeader>
            {I18n.t('BEE4198' /* Espelhar Estoque */)}
          </ModalHeader>
          <ModalBody>
            <div className="form-group text-center align-items-center m-b-10" style={{ height: 100 }}>
              <span className="col-form-label col-md-4">
                {I18n.t('BEE4200' /* Informe o depósito do qual deseja espelhar o estoque */)}
              </span>
              <div className="col-md-12" style={{ marginTop: 10 }}>
                <Select
                  value={deposit}
                  options={listDeposit}
                  onChange={(e) => this.setState({ deposit: e })}
                  isClearable
                  placeholder={I18n.t('BEE144' /* Selecione... */)}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="row">
              <div className="col text-right">
                <OneClickButton
                  className="btn btn-white btn-120 p-5 m-5"
                  onClick={() => { this.setState({ showModalSelectDeposit: false }); }}
                >
                  {I18n.t('BEE99' /* Cancelar */)}
                </OneClickButton>
                <OneClickButton
                  className="btn btn-success btn-120 p-5 m-5"
                  onClick={this.confirmStockMirror}
                  disabled={!deposit}
                >
                  {I18n.t('BEE100' /* Confirmar */)}
                </OneClickButton>
              </div>
            </div>
          </ModalFooter>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  allStockBalancesList: state.stocks && state.stocks.allStockBalancesList,
  enableStockMirror: (state.app && state.app.branchUser && state.app.branchUser.enableStockMirror) || false,
  mainBranch: state.app.userLogged && state.app.userLogged.mainBranch,
});

const mapDispatchToProps = (dispatch) => ({
  getDepositsERPOptionsList: () => dispatch(getDepositsERPOptionsList()),
  generateStockMirror: (branchCode, depositCode) => dispatch(generateStockMirror(branchCode, depositCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllStockBalance));
